
import Vue, { PropType } from 'vue';
import Loading from './loading/Loading.vue';
import ErrorNotification from './error-notification/ErrorNotification.vue';

import EventBus, { Event } from '@/core/event-bus';
import PlayerStateRepository from '../player-state';

export default Vue.extend({
    name: 'Notifications',

    components: {
        Loading,
        ErrorNotification
    },

    props: {
        eventBus: {
            type: Object as PropType<EventBus>,
            required: true
        },
        playerStateRepository: {
            type: Object as PropType<PlayerStateRepository>,
            required: true
        }
    },

    data() {
        return {
            disabled: false
        };
    },

    mounted() {
        this.eventBus.on(Event.disableNotifications, this.onDisableNotifications);
    },

    methods: {
        onDisableNotifications(payload: unknown) {
            this.disabled = payload as boolean;
        }
    }
});
